import { Injectable } from '@angular/core';

import { CredoAppServiceAsync } from "@credolab/credoapp-sdk";
import { AppConfig } from '../config'
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
  })
  export class MetaDataService {
    private url:string;
    private key:string;
    public referencesNumber:string|any;
    public credolabService:any;

    public dataForm = new BehaviorSubject('');

    constructor(){
        this.url = AppConfig.CredoLab.url,
        this.key = AppConfig.CredoLab.authKey
    }

    setDataForm(data:any){
        this.dataForm.next(data);
    }


    InitCredoLabService(){
        this.credolabService = new CredoAppServiceAsync(this.url, this.key);
    }

    StartCredoLabService(){
        this.credolabService.startTrackingAsync(this.CreateReferencesNumber()).then(()=>{
         // alert("Event tracking started and dataset continuously uploaded");
        }, (e:any)=> console.log("error al iniciar el tracking", e))
    }

    StopTracking(){
        this.credolabService.stopTrackingAsync().then(()=>{
          //  alert("Event tracking stopped");
        }, (e:any) => console.log("error al detener el tracking", e))
    }

    CollectionData(){
        this.credolabService.stopTrackingAndCompleteAsync().then(() => {
           // alert("Dataset has been completed");
          }, (e:any) => console.log("error al detener el completado del tracking", e));
    }

    CreateReferencesNumber():string{
        this.referencesNumber = '';
        const data = new Date();
        const dia = data.getDate();
        const mes = data.getMonth() + 1;
        const anio = data.getFullYear();
        const hora = data.getHours();
        const minu = data.getMinutes();
        const mil = data.getMilliseconds()        

        const tiempo = data.getTime();
        const tiempoString = tiempo.toString();
        const key = 'AZYXKHIENO';


        Array.from(tiempoString).forEach((l:string) => {
            this.referencesNumber = (parseInt(l) % 2 == 0) ?  `${this.referencesNumber}${key[l]}` 
                                                       : `${this.referencesNumber}${l}${key[l]}`;
        });

        this.referencesNumber = `CC-HB-INB-${anio}${mes}${dia}${hora}${minu}${mil}-${this.referencesNumber}`; 
        let rn = Array.from(this.referencesNumber);
        this.referencesNumber = ( rn.length >= 40 ) ? this.referencesNumber.substring(0,39) : this.CreateReferencesNumber;
        console.log("rn ", this.referencesNumber);
        return this.referencesNumber;
    }


  }
